<template>
  <el-popover
    v-model="keyboardVisible"
    trigger="manual"
    placement="bottom-start"
    :width="440"
    :visible-arrow="false"
    popper-class="plate-no-input-popper"
    :disabled="disabled"
  >
    <!-- mousedown.prevent：点键盘任意位置都不让输入框失焦，从而不会关闭 -->
    <div @mousedown.prevent>
      <plate-keyboard :value="value" @input="onKeyboardInput"></plate-keyboard>
    </div>
    <el-input
      ref="input"
      slot="reference"
      :value="value"
      :placeholder="placeholder"
      :size="size"
      :disabled="disabled"
      :maxlength="8"
      class="plate-no-input"
      @input="onTextInput"
      @focus="keyboardVisible = true"
      @click.native="keyboardVisible = !disabled"
      @blur="onBlur"
      @keydown.native.esc="keyboardVisible = false"
      @keydown.native.enter="keyboardVisible = false"
    >
      <i
        slot="suffix"
        class="el-icon-keyboard plate-no-input__icon"
        title="车牌键盘"
        @mousedown.prevent
        @click="toggleKeyboard"
      ></i>
    </el-input>
  </el-popover>
</template>

<script>
import PlateKeyboard from '@/components/PlateKeyboard'

/**
 * 车牌号输入框：可直接输入，也可聚焦后用弹出的车牌键盘录入（省份/字母/数字/新能源）。
 * 点击输入框以外区域（输入框失焦）、按 Esc/回车 时收起键盘。创建于 2026-10-10，最后修改：2026-10-10
 * 用法：<plate-no-input v-model="item.plateNo" />
 */
export default {
  name: 'PlateNoInput',
  components: { PlateKeyboard },
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '车牌号' },
    size: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { keyboardVisible: false }
  },
  methods: {
    /** 文本框输入：去空格并转大写 */
    onTextInput(val) {
      this.emitValue(String(val || '').replace(/\s+/g, '').toUpperCase())
    },
    onKeyboardInput(val) {
      this.emitValue(val)
    },
    onBlur() {
      this.keyboardVisible = false
      this.$emit('blur')
    },
    /** 键盘图标：未打开时聚焦输入框并打开；已打开时收起 */
    toggleKeyboard() {
      if (this.disabled) return
      if (this.keyboardVisible) {
        this.keyboardVisible = false
        return
      }
      this.$refs.input && this.$refs.input.focus()
      this.keyboardVisible = true
    },
    emitValue(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style>
.plate-no-input-popper {
  padding: 0 !important;
  border-radius: 10px !important;
  overflow: hidden;
}

.plate-no-input__icon {
  cursor: pointer;
  line-height: inherit;
}

.plate-no-input__icon:hover {
  color: var(--btn-primary, #2563eb);
}
</style>
